<template>
  <div class="fruitBox">
    <div class="fruit" v-for="(fruit, index) in fruitList" :key="index">
      <div class="header" @click="jumpDetail(fruit.id)">
        <!-- 第一排 第xx个完成心愿  查看详情 -->
        <div class="sort">
          <img class="numImg" src="http://img.wish.hebyun.com.cn/images/di_03.png" />
          <span class="num">{{ fruit.serial_num }}</span>
          <img class="sortTImg" src="http://img.wish.hebyun.com.cn/images/ge_03.png" />
        </div>
      </div>
      <!-- 内容区 -->
      <div class="contents" @click="jumpDetail(fruit.id)">
        <div class="title">{{ fruit.title }}</div>
        <div class="details">
          {{ fruit.desc | ellipsis}}
        </div>
        <div class="img_box">
          <div class="img">
            <img :src="fruit.img" />
          </div>
        </div>
        <!-- 满意度展示 -->
        <img
          src="http://img.wish.hebyun.com.cn/images/satisfaction.png"
          class="satisImg"
          alt=""
        />
      </div>
      <!-- 评论区 -->
      <div
        class="comments_box"
        @click="jumpDetail(fruit.id)"
        v-if="fruit.wish_comment !== null"
      >
        <!-- 发布人 -->
        <div class="comment">
          <!-- 发布人 头像 -->
          <div class="avatars">
            <img class="avatar" :src="fruit.wish_comment.publisher.avatar" />
          </div>
          <div class="comment_right">
            <span class="name">{{ fruit.wish_comment.publisher.nick }}</span>
            <span class="info">{{ fruit.wish_comment.publisher.content }}</span>
          </div>
        </div>
        <!-- 认领完成人 -->
        <div class="comment">
          <!-- 认领完成人 头像 -->
          <div class="avatars">
            <img class="avatar" :src="fruit.wish_comment.claimer.avatar" />
            <!-- 认领完成人党徽 -->
            <img
              class="comment_party"
              src="http://img.wish.hebyun.com.cn/images/party.png"
            />
          </div>
          <div class="comment_right">
            <span class="name">{{ fruit.wish_comment.claimer.nick }}</span>
            <span class="info">{{ fruit.wish_comment.claimer.content }}</span>
          </div>
        </div>
      </div>
      <div class="bottom">
        <!-- 时间 -->
        <div class="time" @click="jumpDetail(fruit.id)">{{ fruit.date }}</div>
        <div class="bottom_right">
          <!-- 点赞 👍 -->
          <div class="bottom_thumb" @click="handleThumb(fruit.id, index)">
            <img
              :src="
                fruit.is_thumb === 0
                  ? 'http://img.wish.hebyun.com.cn/images/thumb.png'
                  : 'http://img.wish.hebyun.com.cn/images/thumb_active.png'
              "
            />
            <span
              :class="fruit.is_thumb === 0 ? '' : 'red'"
              v-if="fruit.prize_count > 0"
              >{{ fruit.prize_count }}</span
            >
          </div>
          <!-- 评论 -->
          <div class="bottom_comment" @click="jumpDetail(fruit.id)">
            <img src="http://img.wish.hebyun.com.cn/images/comment.png" />
            <span v-if="fruit.comment_count > 0">{{
              fruit.comment_count
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["fruitList"],
  mounted() {},
  filters: {
    ellipsis(_val) {
      if (!_val) return "";
      if (_val.length > 50) {
        return _val.slice(0, 50) + "...";
      }
      return _val;
    },
  },
  methods: {
    jumpDetail(id) {
      this.$router.push({
        path: "/fruitDetail",
        query: { id: id },
      });
    },
    // 点赞
    handleThumb(id, index) {
      console.log(id, index);
      console.log(this.fruitList);
      if (this.fruitList[index].is_thumb === 0) {
        let data = {
          archieveid: id,
        };
        this.$api.thumbFruit(data);
        this.fruitList[index].is_thumb = 1;
        this.fruitList[index].prize_count += 1;
      } else {
        this.$api.error("请勿重复点赞");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.fruit {
  margin: 11.5px auto 0;
  position: relative;
  padding: 0 14px;
  box-sizing: border-box;
  width: 345px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(219, 0, 2, 0.1);
  border-radius: 8px;
  .header {
    width: 320.5px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .sort {
      display: flex;
      align-items: center;
      padding: 12.5px 0;
      .num {
        font-size: 19px;
        font-weight: 800;
        line-height: 1;
        color: #e60012;
      }
      .numImg {
        width: 14px;
      }
      .sortTImg {
        width: 74px;
      }
    }
  }
  .contents {
    position: relative;
    .title {
      font-size: 18px;
      font-weight: 800;
      line-height: 1;
      color: #333333;
      text-align: left;
    }
    .details {
      font-size: 16px;
      font-weight: normal;
      line-height: 1.5;
      color: #999999;
      margin-top: 4.5px;
      margin-bottom: 7px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-align: left;
    }
    .img_box {
      display: flex;
      width: 100%;
      height: 103px;
      border-radius: 10px;
      margin-bottom: 10px;
      .img {
        display: block;
        flex: 1;
        height: 100%;
        margin-right: 6px;
        border-radius: 10px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .img:last-child {
        margin-right: 0;
      }
    }
    .satisImg {
      position: absolute;
      right: -4px;
      width: 40px;
      height: 40px;
      bottom: -4px;
    }
  }
  .comments_box {
    width: 324.5px;
    // border-bottom: 1px dashed #f7b2b7;
    padding-bottom: 10px;
    .comment {
      display: flex;
      width: 100%;
      margin: 10px 0;
      .avatars {
        position: relative;
        margin-right: 3px;
        .avatar {
          width: 28px;
          height: 28px;
          border-radius: 50%;
        }
        .comment_party {
          position: absolute;
          width: 10px;
          height: 10px;
          top: -1px;
          right: 1px;
        }
      }
      .comment_party {
        position: absolute;
        right: 0;
        top: -2px;
        width: 9px;
        height: 9px;
      }
      .comment_right {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: calc(100% - 33px);
        .name {
          font-size: 11px;
          color: #333333;
          text-align: left;
          line-height: 1;
          margin-bottom: 3px;
        }
        .info {
          font-size: 11px;
          letter-spacing: 0.5px;
          color: #999999;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 280px;
          line-height: 1;
          text-align: left;
        }
      }
    }
  }
  .bottom {
    width: 315px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    padding: 12px 0;
    border-top: 1px dashed rgba(230, 0, 18, 0.2);
    .time {
      font-size: 12px;
      color: #999999;
      opacity: 0.7;
    }
    .bottom_right {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .bottom_thumb {
        position: relative;
        display: flex;
        align-items: center;
        padding: 0 10px;
        img {
          width: 14px;
          height: 12px;
        }
        span {
          font-size: 13px;
          color: #999999;
          margin-left: 4.5px;
        }
        span.red {
          color: #e50012;
        }
      }
      .bottom_thumb::after {
        content: "";
        position: absolute;
        right: 0;
        top: 4px;
        width: 1px;
        height: 9px;
        background-color: #999999;
      }
      .bottom_comment {
        display: flex;
        align-items: center;
        padding: 0 10px;
        img {
          width: 14px;
          height: 13px;
        }
        span {
          font-size: 13px;
          color: #999999;
          margin-left: 3px;
        }
      }
    }
  }
}
.fruit:first-child {
  margin: 0 auto;
}
</style>
